import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from '../services/login.service';
import { LoadIndicatorService } from '../services/load-indicator.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private readonly injector: Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const loginService = this.injector.get(LoginService)
        const loadIndicator = this.injector.get(LoadIndicatorService)

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    loadIndicator.hide()
                    loginService.logout()
                }
                return throwError(() => error);
            })
        );
    }
}
